<template>
  <div ref="cell" class="grid-view__cell grid-field-barcode__cell active">
    <button
      type="button"
      class="grid-field-barcode"
      :aria-label="$t('gridViewFieldBarcode.open')"
      @click="showModal()"
    >
      <BarcodeCanvas
        :value="resolvedSourceValue"
        :format="field.barcode_format"
        :height="28"
      />
    </button>
    <Modal ref="modal" tiny @hidden="modalOpen = false">
      <h2 class="box__title">{{ field.name }}</h2>
      <div class="field-barcode field-barcode--modal">
        <BarcodeCanvas
          :value="resolvedSourceValue"
          :format="field.barcode_format"
          :height="80"
        />
        <p v-if="sourceFieldName" class="field-barcode__source-note">
          {{ $t('rowEditFieldBarcode.sourceNote', { name: sourceFieldName }) }}
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import gridField from '@baserow/modules/database/mixins/gridField'
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import { isInsideTeleportedElement } from '@baserow/modules/core/utils/dom'
import BarcodeCanvas from '@baserow/modules/database/components/field/BarcodeCanvas'

export default {
  name: 'GridViewFieldBarcode',
  components: { BarcodeCanvas },
  // Read-only is "nothing to write", not "nothing to open" -- viewing an
  // enlarged code must work the same as `GridViewFieldFile`'s lightbox,
  // which never gates opening on `readOnly`, only uploading a replacement.
  mixins: [gridField, sourceFieldReferenceField],
  data() {
    return {
      modalOpen: false,
    }
  },
  computed: {
    sourceFieldName() {
      const fields =
        this.allFieldsInTable?.length > 0
          ? this.allFieldsInTable
          : this.$store.getters['field/getAll']
      return fields.find((f) => f.id === this.field.source_field_id)?.name
    },
  },
  methods: {
    showModal() {
      this.modalOpen = true
      this.$refs.modal.show()
    },
    // Mirrors `GridViewFieldFile`: the modal lives at the root of the body
    // element (teleported), so without this the cell's own click-outside
    // handler would see the click as outside the cell and unselect it,
    // closing the modal a frame after it opened.
    canUnselectByClickingOutside(event) {
      return !isInsideTeleportedElement(this.$refs.modal, event)
    },
    beforeUnSelect() {
      if (this.modalOpen) {
        this.$refs.modal.hide()
      }
    },
  },
}
</script>
